// extracted by mini-css-extract-plugin
export default {"plaidLinkContainer":"style_plaidLinkContainer__tvVcn"};